import RoleModelingBox from "./role-modeling-box.jsx";

export default RoleModelingBox;